<template>
<div id="edit-form">
  <user-form
    :userId="userId"
  ></user-form>
</div>
</template>

<script>
import UserForm from '@/components/UserForm'

import UserStore from '@/stores/UserStore'

export default {
  data () {
    return UserStore.state
  },

  components: {
    'user-form': UserForm
  },

  props: ['userId']
}
</script>



// WEBPACK FOOTER //
// src/components/UserEdit.vue